import React from "react";
import { Popover as MuiPopover } from "@gti-controls-v2/web-core";

export const Popover = ({
	id,
	open,
	anchorEl,
	anchorOrigin,
	transformOrigin,
	anchorReference,
	anchorPosition,
	onClose,
	...props
}) => {
	return (
		<MuiPopover
			id={id}
			open={open}
			anchorEl={anchorEl}
			anchorOrigin={
				anchorOrigin || {
					vertical: "bottom",
					horizontal: "center",
				}
			}
			transformOrigin={{
				vertical: "top",
				horizontal: "left",
			}}
			anchorReference={anchorReference}
			anchorPosition={anchorPosition}
			onClose={onClose}
			disableRestoreFocus
		>
			{props.children}
		</MuiPopover>
	);
};

export default Popover;
